import { render } from "./calendar-popup.vue?vue&type=template&id=63977784"
import script from "./calendar-popup.vue?vue&type=script&lang=js"
export * from "./calendar-popup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__